import handleQueryError from '../../../../util/Common/Error/Handler/handleQueryError';
import safetyDefaultAPI from '../../api';

const getSpecificMRData = async ({ seq }) => {
  try {
    const response = await safetyDefaultAPI.get(`mr/${seq}`);
    return response;
  } catch (error) {
    throw new Error(handleQueryError({ error }));
  }
};

export default getSpecificMRData;
